export default __webpack_public_path__ + "static/media/button_press.972fd430.mp3";